import React from "react";
import { FieldArray, useFormikContext } from "formik";
import Input from "./InputField";
import FormFieldArray from "./FormFieldArray";
import Collapsible from "react-collapsible";
import { IoCloseCircle } from "react-icons/io5";

const NoteArray = () => {
  const { values } = useFormikContext();

  return (
    <FieldArray name="notes">
      {({ insert, remove, push }) => (
        <div>
          <button
            type="button"
            className="border border-slate-600 text-sm px-2 py-1.5 mb-2 w-full mt-2"
            onClick={() =>
              push({
                text: "",
                activeStatus: true,
              })
            }
          >
            Add Note
          </button>

          {values.notes.length > 0 &&
            values.notes.map((note, index) => (
                <div className="flex w-full flex-col border border-gray-300 rounded p-3 mb-3" key={index}>
                       <IoCloseCircle
                        onClick={() => remove(index)}
                        className="text-red-600 text-xl self-end  cursor-pointer transition-all ease-in-out hover:scale-110"
                      />
                    <Input
                      name={`notes.${index}.text`}
                      id={`notes.${index}.text`}
                      placeholder="Type Note"
                      label="Note"
                      type='textarea'
                    />
                </div>
            ))}
        </div>
      )}
    </FieldArray>
  );
};

export default NoteArray;
